const buildSuccess = (_message, _data = null) => {
  return {
    status: 'success',
    message: _message,
    data: _data,
  };
};

const buildFailure = (_message, _data = null) => {
  return {
    status: 'failure',
    message: _message,
    data: _data,
  };
};

const buildBlockchainFailure = (_error) => {
  if (_error.error != null && _error.error.code != null) {
    if (_error.error.code && _error.error.code === -32002) {
      return buildFailure(
        'You have already initiated a request for connection, please select on the metamask extension to proceed further.',
      );
    } else {
      return buildFailure(_error.message);
    }
  } else if (
    _error.data != null &&
    _error.data !== undefined &&
    _error.data.message !== undefined
  ) {
    return buildFailure(_error.data.message);
  } else if (_error.code) {
    if (_error.code === 4001 || _error.code === 'ACTION_REJECTED') {
      return buildFailure('You rejected the metamask connection request');
    } else if (
      _error.code === 'UNSUPPORTED_OPERATION' &&
      _error.operation === 'getAddress'
    ) {
      const _errorCode = {
        code: _error.code,
        operation: _error.operation,
      };
      return buildFailure(_error.message, _errorCode);
    } else if (_error.code === 'NETWORK_ERROR') {
      const _errorCode = {
        code: _error.code,
      };
      return buildFailure(_error.message, _errorCode);
    } else if (
      _error.code === 'CALL_EXCEPTION' &&
      _error.action === 'estimateGas'
    ) {
      const _errorCode = {
        code: _error.code,
      };
      if (_error.reason) {
        return buildFailure(_error.reason);
      }
      return buildFailure(
        'Cannot estimate the gas fee for the performed operation',
        _errorCode,
      );
    } else if (_error.reason) {
      return buildFailure(_error.reason);
    } else {
      return buildFailure(_error.message);
    }
  } else {
    return buildFailure(_error.message);
  }
};

export { buildSuccess, buildFailure, buildBlockchainFailure };
